module.exports = "pegasus/assets/theme5/medium/4.jpg";